import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';
import Carousel from '../../Helpers/Widgets/AutoSwipeCarousel/AutoSwipeCarousel';
import './Carriers.scss'

export default function Carriers(props) {

  // default carriers when we don't have account setup
  const defaultCarriers = [];

  const [carriers, setCarriers] = useState(defaultCarriers);
  const carrierVerbiage = props.carrierVerbiage || 'We work with leading insurance companies';
  const [currentIndex, setCurrentIndex] = useState(parseInt((window.innerWidth - 250) / 180, 10))
  const [showCarouselArrow, setShowCarouselArrow] = useState(false);

  const checkShowCarouselArrow = (count) => {
    const width = window.innerWidth - 250;
    const totalWidthRquired = 180 * count;
    if (totalWidthRquired > width) {
      setShowCarouselArrow(true)
    }
    else {
      setShowCarouselArrow(false);
    }
  }

  const noOfCardDispalyed = () => {
    return parseInt((window.innerWidth - 250) / 180, 10);
  }

  const changeCurrentIndex = (side) => {
    if (side === "NEXT") {
      setCurrentIndex(currentIndex + 1)
    }
    else {
      setCurrentIndex(currentIndex - 1)
    }
  }

  useEffect(() => {
    async function GetAccCarriers() {
      const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

      const accountCarriers = accountObj && accountObj.accountCarriers;
      
      const uniqueCarriers = accountCarriers.reduce((acc, carrier) => {
        const logoLinks = new Set(acc.map(c => c.logoLink));
        if (!logoLinks.has(carrier.logoLink)) {
          acc.push(carrier);
        }
        return acc;
      }, []);

      const productCarrierList = props.category
        ? accountCarriers.filter(c => c.productCategory && c.productCategory.includes(props.category))
        : uniqueCarriers;

      if (productCarrierList.length > 0) {
        setCarriers(productCarrierList);
        checkShowCarouselArrow(productCarrierList.length);
      } else if (props.productCarriers) {
        setCarriers(props.productCarriers);
        checkShowCarouselArrow(props.productCarriers.length);
      }
      else {
        checkShowCarouselArrow(cards.length);
      }
    }

    GetAccCarriers();
    window.addEventListener('resize', handleResize);
  }, []);  

  const handleResize = () => {
    if (showCarouselArrow){
      setCurrentIndex(parseInt((window.innerWidth - 250) / 180, 10))
      checkShowCarouselArrow(cards.length);
    }
  }
  const cards = carriers.map((obj) => <div className={`p-2 carouselItem`} key={obj.displayOrder}>
    <img src={obj.logoLink} alt={`${obj.carrierName} logo`} height="75px"/>
  </div>)

  return (
    <div className="row">
      <div className={`carriers home-section w-100 px-0 col-lg ${props.isBasic ? "whiteBackground" : "background-primary"}`}>
        {!props.isBasic && <Row className="carriers-content-section justify-content-center">
          <h3>{carrierVerbiage}</h3>
        </Row>}
        {showCarouselArrow ?
            <div className="row carousel-container">
              <Carousel items={cards} numItems={cards.length} showArrow={false} noOfCardDispalyed={noOfCardDispalyed()} changeCurrentIndex={changeCurrentIndex} currentIndex={currentIndex} indicators={false} isAutoCarousel={true} />
            </div> :
            <Row className='justify-content-center gap'>
              {cards}
            </Row>}
      </div>
    </div>
  );
}
